import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { UpdatePrompt } from './app/pwa/UpdatePrompt.js';
import { SessionProvider } from './app/providers/SessionProvider.js';
import { AppRouter } from './app/router/AppRouter.js';
import './shared/styles/global.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <SessionProvider>
      <AppRouter />
      <UpdatePrompt />
    </SessionProvider>
  </StrictMode>,
);
